// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    suggestionMobileStyle: "style1",
  },
};

// Override Settings
(function () {
  // Add this
  BoostPFS.inject(this); // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function (
    suggestionElement,
    searchElement,
    searchBoxId
  ) {};
  InstantSearchMobile.prototype.afterBindEvents = function () {
    var self = this;

    jQ('.header__action-item-link[data-action="toggle-search"]')
      .off("click")
      .click(function (e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ(".search-bar__input").focus();
        self.openSuggestionMobile();
      });
  };
  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function (
    isClose
  ) {
    //Fix conflict with theme search
    jQ(".header__search-bar-wrapper").removeClass("is-visible");
    jQ("header.header.header--inline").removeClass("header--search-expanded");
  };

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice =
    function () {
      // If the multi-currency feature is enabled, update the product price
      this.prepareSuggestionProductPriceData();
      // Check on sale
      var onSale = this.data.compare_at_price_min > this.data.price_min;
      // Format price
      var price = Utils.formatMoney(this.data.price_min);
      var compareAtPrice = "";
      if (this.data && this.data.compare_at_price_min) {
        compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue("search.removePriceDecimal")) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }
      // If "printer" template is assigned, price must be hidden.
      var isHidePrice = this.data.template_suffix == "printer";
      // Build Price
      var result = "";
      if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
        if (
          onSale &&
          Settings.getSettingValue("search.showSuggestionProductSalePrice")
        ) {
          result = isHidePrice
            ? ""
            : this.getTemplate(
                InstantSearchResultItemProduct.tempType.PRICE_SALE
              );
        } else {
          result = isHidePrice
            ? ""
            : this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        }
      }
      return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
    };
})(); // Add this at the end
